<template>
    <div class="lg:flex container mx-auto py-4 lg:space-x-4 px-2 md:px-0">
        <jet-form-main @submitted="faqCreate" class="lg:w-2/3">
            <template #title>
            </template>

            <template #description>
            </template>
            
            <template #form>
                <!-- Title -->
                <div>
                    <jet-label for="question" value="Pergunta" class="font-bold" />
                    <jet-input type="text" v-model="form.question" class="w-full"/>
                    <jet-input-error :message="form.errors.question" />
                </div>

                 <div>
                    <jet-label for="answer" value="Resposta" class="font-bold" />
                    <text-area-input rows="10" v-model="form.answer" class="w-full"></text-area-input>
                    <jet-input-error :message="form.errors.answer" />
                </div>
            </template>
        </jet-form-main>

        <div class="px-4 py-5 bg-white sm:p-6 shadow rounded-md mt-1 relative h-full lg:flex-1">

            <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="relative bottom-0 bg-primary-900 text-center w-full justify-center text-lg tracking-normal mt-10 rounded-full" @click.prevent="faqUpdate" v-if="faq">Atualizar</jet-button>
            
            
            <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="relative bottom-0 bg-primary-900 text-center w-full justify-center text-lg tracking-normal mt-10 rounded-full" @click.prevent="faqCreate" v-else>Criar</jet-button>

            <div class="flex justify-between mt-4">
                <jet-button @click.prevent="backToFaqs()" class="bg-transparent hover:bg-transparent focus:bg-transparent active:bg-transparent border-0 active:border-0 focus:border-0 focus:ring-transparent active:shadow-0 focus:shadow-0 underline text-violet-500 px-0"><icon name="back" />Voltar</jet-button>

                <jet-button v-if="faq" @click.prevent="removeFaq(faq)" class="bg-transparent hover:bg-transparent focus:bg-transparent active:bg-transparent border-0 active:border-0 focus:border-0 focus:ring-transparent active:shadow-0 focus:shadow-0 underline text-amber-600 px-0"><icon name="trash" class="w-3 h-3" /> Remover</jet-button>
            </div>

        </div>
    </div>
</template>

<style>
    .ql-toolbar.ql-snow {
        border-radius: 0.375rem 0.375rem 0 0;
    }
    .ql-container.ql-snow {
        border-radius: 0 0 0.375rem 0.375rem;
    }
</style>

<script>
    import { defineComponent } from 'vue'
    import BackLayout from '@/Layouts/BackLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import TextAreaInput from '@/Jetstream/TextAreaInput.vue'
    import JetActionMessage from '@/Jetstream/ActionMessage.vue'
    import JetButton from '@/Jetstream/Button.vue'
    import JetFormMain from '@/Jetstream/MainForm.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetInputError from '@/Jetstream/InputError.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import JetModal from '@/Jetstream/Modal.vue'
    import JetCheckbox from '@/Jetstream/Checkbox.vue'
    import JetDialogModal from '@/Jetstream/DialogModal.vue'
    import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'
    import Icon from '@/Jetstream/Icon'
    import FileInput from '@/Components/FileInput.vue'
    import { VueEditor, Quill } from "vue3-editor";

    export default defineComponent({
        components: {
            Head,
            Link,
            JetInput,
            TextAreaInput,
            JetLabel,
            JetActionMessage,
            JetButton,
            JetFormMain,
            JetInputError,
            JetModal,
            JetCheckbox,
            JetDialogModal,
            JetSecondaryButton,
            Icon,
            VueEditor,
            FileInput
        },
        layout: BackLayout,
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            categories: Array,
            faq: Object,
        },
        data() {
            return {
                form: this.$inertia.form({
                    question: '',
                    answer: ''
                })
            }
        },
        computed: {
        },
        created() {
            if(this.faq != null) {
                this.form.question = this.faq.question
                this.form.answer = this.faq.answer
            }
        },
        methods: {
            faqCreate() {
                this.form.post(route('faqs.store'), {
                    errorBag: 'faqCreate',
                    preserveScroll: true,
                    onSuccess: () => this.form.reset(),
                    onError: () => {
                    }
                })
            },
            faqUpdate() {
                this.form.put(route('faqs.update', this.faq ), {
                    method: 'PUT',
                    errorBag: 'faqUpdate',
                    preserveScroll: true
                })
            },
            removeFaq(faq) {
                if(confirm('Tem certeza? Esta ação é irreversível.')){
                    this.$inertia.delete(route('faqs.destroy', faq));
                }
            },
            backToFaqs() {
                this.$inertia.get(route('faqs.index'))
            }
        },
    })
</script>